<template>
  <div class="container">

    <div class="mask"></div>

    <div class="flex">

      <div class="dialog">

        <div class="close-layout">
          <div class="close-left"></div>
          <img class="close-view"
               src="@/assets/common_icon_close.png"
               @click="listeners.onClose()"
          />
        </div>

        <div class="title-view">{{ title }}</div>
        <div class="desc-view">{{ desc }}</div>
        <a class="op-layout" style="text-decoration: none">
          <div class="divider"></div>
          <div class="bottom">
            <div class="op-cancel-view" v-if="cancel_op" @click="listeners.onClose()">{{ cancel_op }}</div>
            <div class="divider2" v-if="cancel_op"></div>
            <div class="op-view" @click="listeners.onClick(item)">{{ op }}</div>
          </div>
        </a>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'AIPatternDialog',

  props: {
    title: {
      Type: String
    },
    desc: {
      Type: String
    },
    op: {
      Type: String
    },
    cancel_op: {
      Type: String
    },
    cmd: {
      Type: String
    },
    item: {
      Type: String
    },
    listeners: {}
  },

}
</script>

<style scoped>


.container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.5;
}

.flex {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.flex .dialog {
  width: 82%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 1.25rem;
  box-sizing: border-box;
}

.dialog .close-layout {
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: row;
}

.dialog .close-layout .close-left {
  flex: 1;
}

.dialog .close-layout .close-view {
  width: 0.94rem;
  height: 0.94rem;
  padding: 0.47rem;
  margin-top: 0.47rem;
  margin-right: 0.47rem;
}

.title-view {
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 1.10rem;
  color: #333333;
  text-align: center;
  margin-top: -0.47rem;
}

.desc-view {
  font-family: PingFangSC-Regular;
  font-size: 1.00rem;
  color: #333333;
  text-align: center;
  margin-top: 0.94rem;
}

.divider {
  width: 100%;
  height: 0.03rem;
  background-color: #E5E5E5;
}

.op-layout {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 1.25rem;
  margin-bottom: 0rem;
}

.op-view {
  flex: 1;
  margin-top: 0.6rem;
  color: #2289FF;
  height: 2.4rem;
}


.op-cancel-view {
  flex: 1;
  margin-top: 0.6rem;
  color: #000000;
  height: 2.4rem;
}

.divider2 {
  width: 0.03rem;
  height: 3rem;
  background-color: #DDDDDD;
}

.bottom {
  display: flex;
  width: 100%;
  flex-direction: row;
}

</style>



// WEBPACK FOOTER //
// src/components/dialog/AIPatternDialog.vue